module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_th-f0b93b2d14c85d333d3678a0fc033816.jpg";